import { render, staticRenderFns } from "./CardOwner.vue?vue&type=template&id=05dc63a2"
import script from "./CardOwner.vue?vue&type=script&lang=js"
export * from "./CardOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports